import type { TaskWithProgress } from '../../types/server/models/blueprint'
import UtilSrvice from '../../services/util-service'
import style from '../../assets/style.json'
import FileSaver from 'file-saver'
import Swal from 'sweetalert2'
import { SubmitBlueprint, useTasksProgressByRole } from '../../services/blueprint.service'
import { PrimaryButton } from '../../components/Footer/styleComponent/PrimaryButton'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useGetCompanyByUserId } from '../../services/company-service'
import { FileInfoButton } from '../../assets/FileInfoButton'
import { CirclePlusIcon } from '../../assets/CirclePlusIcon'
import { DownloadIcon } from '../../assets/DownloadIcon'
import { UploadFiles } from '../../utils/hooks/useFiles'
import { useRoleStore } from '../../components/Topbar'
import { useUser } from '../../services/user-service'
import { TrashIcon } from '../../assets/TrashIcon'
import { getMimeType } from '../../services/mime'
import { EditIcon } from '../../assets/EditIcon'
import { LikeIcon } from '../../assets/LikeIcon'
import { InfoIcon } from '../../assets/InfoIcon'
import { useTranslation } from 'react-i18next'
import { appConfig } from '../../configs/app'
import { useEffect, useState } from 'react'
import {
	Button,
	Box,
	Checkbox,
	Container,
	Text,
	VStack,
	SlideFade,
	Textarea,
	Accordion,
	AccordionItem,
	AccordionButton,
	AccordionPanel,
	AccordionIcon,
	useDisclosure,
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalCloseButton,
	ModalBody,
	ModalFooter,
	useMediaQuery,
} from '@chakra-ui/react'
import { addMonths, setDate } from 'date-fns'
import { ConvertIntervalToMS } from '../../utils/interval-helpers'
import { useLiteModalAlert } from '../../components/LiteModal'
// import useLocalStorage from '../../utils/hooks/useLocalStorage'

const TasksForm = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const [searchParams] = useSearchParams()
	const [isSubmitting, setIsSubmitting] = useState(false)

	const id = useParams<{ id?: string }>().id
	const userId = searchParams.get('user_id') || undefined

	// const [fileId, setFileId] = useState('')
	const { isOpen, onOpen, onClose } = useDisclosure()
	const [selectedItem, setSelectedItem] = useState<string | null>(null)
	const [isPc] = useMediaQuery('(min-width: 1300px)')

	const { data: loggedUser } = useUser()
	const { user } = useUser(userId)
	const { data: company } = useGetCompanyByUserId(user?.id)

	const isCompanyLite = company?.lite || false

	// not sure if we need _id or id
	const isOwner = loggedUser?.id === userId || !userId
	console.log({ isOwner, userId, user })

	const role = userId ? user?.roles[0] : useRoleStore((state) => state.role)
	const currentRoleId = id || role?._id // Use either the role specified in the URL or the current role

	const [progress, setProgress] = useState<TaskWithProgress[]>([])
	console.log({ progress })
	const [isDownloading, setIsDownloading] = useState(false)

	const now = new Date()

	useEffect(() => {
		if (!isOpen) setSelectedItem(null)
	}, [isOpen])

	const {
		data: { tasks },
		isLoading,
		mutate
	} = useTasksProgressByRole(currentRoleId, userId, true)

	console.log({ tasks })

	// const [readTasks, setReadTasks] = useLocalStorage('read-tasks', [] as string[])

	// Set the progress state based on the tasks data
	useEffect(() => {
		if (tasks) {
			setProgress(tasks)

			// setReadTasks((prev) => {
			// 	// Filter out tasks that are already read
			// 	const newTasks = tasks.filter((task) => !prev.includes(task._id)).map((task) => task._id)

			// 	// Combine with existing read tasks and remove duplicates
			// 	return Array.from(new Set([...prev, ...newTasks]))
			// })
		}
	}, [tasks, role])

	const downloadFile = async (fileName: string, path: string) => {
		if (isDownloading) return
		setIsDownloading(true)

		try {
			const response = await fetch(`${path}&fileName=${fileName}`)
			const data = await response.blob()

			const splittedFileName = fileName.split('.')
			const extension = splittedFileName.at(splittedFileName.length - 1)

			const fixedData = new Blob([data], { type: getMimeType(extension ?? '') })
			FileSaver.saveAs(fixedData, fileName)
		} finally {
			setIsDownloading(false)
		}
	}

	const [taskId, setTaskd] = useState<string>()

	const uploadFile = async (taskId: string) => {
		setTaskd(taskId)
		document.getElementById('fileInput')?.click()
	}

	const handleFileInput = async (e: React.ChangeEvent<HTMLInputElement>) => {
		if (isSubmitting) return
		if (!e.target?.files) return
		if (!taskId) return

		setIsSubmitting(true)

		const fileArr = e.target?.files ? Array.from(e.target.files) : []

		const uploadedFiles = await UploadFiles(fileArr)

		// Add it to the task progress under the taskId
		const task = progress.find((task) => task._id === taskId)
		if (task) {
			const newProgress = progress.map((task) => {
				if (task._id === taskId) {
					console.log({ task })
					return {
						...task,
						files: [...(task.files || []), ...uploadedFiles],
					}
				}

				return task
			})

			setProgress(newProgress)
		}

		e.target.value = ''
		e.target.files = null

		setIsSubmitting(false)
	}

	const deleteFile = async (path: string, taskId: string) => {
		const file = progress.find((task) => task._id === taskId)?.files?.find((file) => file.path === path)

		if (file) {
			const result = await Swal.fire({
				title: `${t('tasksForm.deleteFile')} ${file.name}?`,
				text: t('tasksForm.deleteWarning'),
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				cancelButtonText: t('tasksForm.cancel'),
				confirmButtonText: t('tasksForm.delete'),
			})

			if (result.isConfirmed) {
				// Remove the file
				const newProgress = progress.map((task) => {
					if (task._id === taskId) {
						return {
							...task,
							files: task.files?.filter((file) => file.path !== path),
						}
					}

					return task
				})

				setProgress(newProgress)
			}
		}
	}

	const handleSubmit = async () => {
		if (isSubmitting) return

		setIsSubmitting(true)

		try {
			const result = await Swal.fire({
				title: t('tasksForm.tasksApproval'),
				text: t('tasksForm.appreciation'),
				input: 'checkbox',
				inputPlaceholder: t('tasksForm.comprehension'),
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				cancelButtonText: t('tasksForm.cancel'),
				confirmButtonText: t('tasksForm.approve'),
				inputValidator: (result: string) => {
					return !result && t('tasksForm.readAndConfirm')
				},
			})

			if (result.isConfirmed && result.value) {
				await SubmitBlueprint({
					userId: user?.id,
					tasks: progress.map((task) => ({
						taskId: task._id,
						checked: task.checked,
						notes: task.notes,
						files: task.files,
					})),
				})

				await mutate()

				navigate('/home')
				Swal.fire(t('tasksForm.success'), t('tasksForm.tasksSent'), 'success')
			}
		} catch (e) {
			Swal.fire(t('tasksForm.error'), t('tasksForm.tryAgainLater'), 'error')
		}

		setIsSubmitting(false)
	}

	// Filter out the tasks that are not relevant to the current role
	// const relevantTasks = progress.filter((task) => {
	// 	const taskRoleId = typeof task.blueprint === 'string' ? null : task.blueprint.role
	// 	if (!taskRoleId) return false

	// 	// Check if the current role is equal to the task role
	// 	if (taskRoleId === currentRoleId) return true

	// 	return false
	// })

	const handleOpen = useLiteModalAlert()

	return (
		<Container
			maxW='full'
			minH='100vh'
			bg={'transparent'}
			position='absolute'
			centerContent
			top={'140px'}
			padding={0}
		>
			<Modal
				isOpen={isOpen}
				onClose={onClose}
			>
				<ModalOverlay />
				<ModalContent>
					<ModalHeader
						display='flex'
						alignItems={'center'}
						justifyContent='center'
						textAlign={'center'}
						color={style['primary-color']}
						gap='30px'
						position={'relative'}
					>
						<LikeIcon scale={0.7} />
						<Text color='#475154'>{t('tasksForm.addComments')}</Text>
					</ModalHeader>
					<ModalCloseButton
						position={'absolute'}
						top={'-40px'}
						color={'white'}
						border={'1px solid white'}
						rounded={'100px'}
						left={0}
						right='unset'
					/>
					<ModalBody>
						<Textarea
							placeholder={t('tasksForm.enterComment')}
							isDisabled={!isOwner}
							value={progress.find((task) => task._id === selectedItem)?.notes || ''}
							// disabled={!!user || !data?.date}
							disabled={!isOwner}
							bg={'#ECEDF0'}
							rows={10}
							marginBottom={'30px'}
							resize='none'
							onChange={(e) => {
								const newProgress = progress.map((task) => {
									if (task._id === selectedItem) {
										return {
											...task,
											notes: e.target.value,
										}
									}

									return task
								})

								setProgress(newProgress)
							}}
						/>
					</ModalBody>
					<ModalFooter width={'full'}>
						<PrimaryButton
							styles={{ minW: 'full' }}
							onClick={onClose}
						>
							{t('tasksForm.save')}
						</PrimaryButton>
					</ModalFooter>
				</ModalContent>
			</Modal>

			<SlideFade in>
				<Text
					// pb={date ? 0 : 7}
					fontWeight={500}
					color={'#fff'}
					fontSize={32}
				>
					{userId ? t('tasksForm.planningExecution') : t('tasksForm.myTasks')}

					<iframe
						style={{ display: 'none' }}
						id='preview-iframe'
						width='100%'
						height='600px'
						title='Preview'
					/>
				</Text>
			</SlideFade>
			{/* {date && ( */}
			<SlideFade in>
				<Text
					pb={3}
					color={'#fff'}
					fontWeight='400'
					fontSize={18}
					cursor='pointer'
					lineHeight={'60px'}
				>
					{UtilSrvice.timestampToDDMMYYYY(new Date()?.getTime() ?? new Date().getTime())}
				</Text>
			</SlideFade>
			{/* )} */}

			<Box
				display='flex'
				minH={isLoading ? 500 : 'auto'}
				alignItems='center'
				justifyContent='center'
				bg={'#fafafa'}
				width='full'
			>
				{isLoading ? (
					<div className='lds-default'>
						<div />
						<div />
						<div />
						<div />
						<div />
						<div />
						<div />
						<div />
						<div />
						<div />
						<div />
						<div />
					</div>
				) : !progress.length ? (
					<Text
						mt={40}
						fontSize={23}
						opacity={0.4}
					>
						{t('tasksForm.noTasks')}
					</Text>
				) : (
					<Accordion
						w='100%'
						maxW={style['pc-view']}
						allowMultiple={true}
					>
						{!!userId && (
							<Box
								bg='#FFFFFF'
								boxShadow='0px 0px 25px rgba(62, 62, 62, 0.08)'
								mt='-50px'
								width={isPc ? '444px' : '300px'}
								mb={8}
								rounded='10px'
								padding='18px'
								textAlign='center'
								marginInline='auto'
								position='relative'
							>
								<Box
									right={'50%'}
									top={'0'}
									transform='translate(50%,-50%)'
									bg={'white'}
									position='absolute'
									padding={'5px'}
									rounded='50%'
								>
									<InfoIcon />
								</Box>
								<Text fontSize={'18px'}>{t('tasksForm.formBelongs')}</Text>
								<Box
									rounded={'8px'}
									display={'flex'}
									bg='#F5F8FA'
									padding={'10px'}
									justifyContent='space-between'
								>
									<Text
										fontSize={'20px'}
										fontWeight='600'
									>
										{user?.name}
									</Text>
									<Text
										fontSize={'20px'}
										fontWeight='600'
									>
										{user?.phone}+
									</Text>
								</Box>
							</Box>
						)}

						<input
							type='file'
							id='fileInput'
							style={{ visibility: 'hidden', width: 0, height: 0 }}
							onChange={handleFileInput}
							multiple
						/>

						{(company?.exposureCategories ?? []).map((section, sectionIndex) => {
							const filteredTasks = progress?.filter((c) => c.riskId === section.id)
								?.sort((a, b) => (a.order || 0) - (b.order || 0)) // Sort by order field

							if (!filteredTasks.length) {
								return null
							}

							const isRiskLite = (isCompanyLite && section.isLockedInLite) || false

							return (
								<AccordionItem
									w={'full'}
									margin={'0px'}
									borderTop='0'
									borderBottom={'1.5px solid #F0EEEE'}
									key={section._id}
								>
									<AccordionButton
										display='flex'
										justifyContent='space-between'
										paddingBlock={'30px'}
									>
										<Text
											fontWeight={600}
											fontSize={22}
											textAlign='start'
											// filter={isRiskLite ? 'blur(6px)' : 'none'}
										>
											{section.name}
										</Text>
										<Box
											display={'flex'}
											alignItems='center'
											gap={'20px'}
										>
											<Text
												fontSize={'18px'}
												fontWeight={500}
												color={
													filteredTasks.filter(
														(item) =>
															item.checked ||
															progress.find((task) => task._id === item._id)?.checked
													).length === progress.length
														? '#3FB2D2'
														: '#aaa'
												}
											>
												{
													filteredTasks.filter(
														(item) =>
															item.checked ||
															progress.find((task) => task._id === item._id)?.checked
													).length
												}
												/{filteredTasks.length}
											</Text>
											<AccordionIcon />
										</Box>
									</AccordionButton>
									<AccordionPanel onClick={isRiskLite ? () => handleOpen('tasks') : undefined}>
										<VStack
											key={`section-${
												// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
												sectionIndex
											}`}
											w='100%'
											alignItems='flex-start'
										>
											<VStack
												w='100%'
												spacing={1}
											>
												{(filteredTasks ?? []).map((item) => {
													const nextReset = ((): Date | null => {
														if (!item.checked) return null

														const { lastReset, interval, intervalAmount, dayOfMonth } = item
														const lastResetDate = new Date(lastReset)

														if (interval === 'MONTH' && dayOfMonth) {
															// Calculate the next reset date based on the last reset date and the day of the month
															// Also calculate the interval * interval amount (e.g. 1 MONTH, 2 MONTHS, etc.)
															const nextResetDate = setDate(
																addMonths(lastReset, intervalAmount),
																dayOfMonth
															)

															console.log({
																lastReset,
																nextResetDate,
																lastResetDate,
																now,
															})

															return nextResetDate
														}

														const lastResetTime = lastResetDate.getTime()
														if (!lastResetTime) return null

														const ms = ConvertIntervalToMS(interval, intervalAmount)
														const nextResetTime = lastResetTime + ms
														const nextResetDate = new Date(nextResetTime)

														const start = new Date(item.startDate)
														const end = new Date(item.endDate || 0)

														if (now > end) {
															return end
														}

														if (now < start) {
															return start
														}

														return nextResetDate
													})()

													return (
														<Box
															key={item._id}
															bg={
																item.checked ||
																progress.find((progress) => progress._id === item._id)
																	?.checked
																	? '#F7FCFE'
																	: 'white'
															}
															w='100%'
															boxShadow={'0px 0px 25px rgba(62, 62, 62, 0.08)'}
															rounded='10px'
														>
															<Box
																padding={'25px 20px'}
																display='flex'
																alignItems={'center'}
																gap={'33px'}
															>
																<Box
																	display='flex'
																	alignItems={'center'}
																	flex={1}
																	gap={'33px'}
																>
																	<Checkbox
																		// disabled={!!user || !data?.date} // todo check that
																		disabled={!isOwner || isRiskLite}
																		size='lg'
																		colorScheme='white'
																		borderColor='#3FB2D2'
																		iconColor='#3FB2D2'
																		iconSize={'17px'}
																		spacing='1rem'
																		p={2}
																		rounded='xl'
																		wordBreak='break-word'
																		// isDisabled={data?.locked || !data?.date} // todo check that
																		defaultChecked={item.checked}
																		onChange={(e) => {
																			const newProgress = progress.map((task) => {
																				if (task._id === item._id) {
																					return {
																						...task,
																						checked: e.target.checked,
																					}
																				}

																				return task
																			})

																			// @ts-ignore
																			setProgress(newProgress)
																		}}
																	>
																		<span
																			style={{
																				filter: isRiskLite
																					? 'blur(5px)'
																					: 'none',
																			}}
																		>
																			{item.text}
																		</span>
																	</Checkbox>
																	<Box
																		display='flex'
																		alignItems={'center'}
																		flexWrap='wrap'
																		gap={'20px'}
																	>
																		{(item.adminFiles ?? []).map((file) => {
																			console.log({ file })
																			const { name, path } = file

																			return (
																				<Button
																					size='sm'
																					fontSize={21}
																					bg={style['primary-color']}
																					width='34px'
																					isLoading={isDownloading}
																					isDisabled={isDownloading}
																					height='34px'
																					color={'white'}
																					onClick={() =>
																						downloadFile(
																							name,
																							`${
																								appConfig.apiUrl
																							}/file?path=${path}&token=${localStorage.getItem(
																								'token'
																							)}`
																						)
																					}
																					key={file.path}
																					disabled={isRiskLite}
																				>
																					<FileInfoButton />
																				</Button>
																			)
																		})}
																	</Box>
																</Box>

																{isPc && isOwner && (
																	<>
																		<Button
																			// disabled={!!user || !data?.date} // todo
																			disabled={!isOwner || isRiskLite}
																			onClick={() => uploadFile(item._id)}
																			minW={'188px'}
																			textAlign='center'
																			fontSize='18px'
																			fontWeight={700}
																			rounded={'100px'}
																			borderWidth={'1.5px'}
																			// borderColor={
																			// 	!!files.find(
																			// 		(f) => f.id === item._id
																			// 	)?.name
																			// 		? '#E55353'
																			// 		: style['primary-color']
																			// }
																			bg={'#fff'}
																			// color={
																			// 	!!files.find(
																			// 		(f) => f.id === item._id
																			// 	)?.name
																			// 		? '#E55353'
																			// 		: style['primary-color']
																			// }
																		>
																			{/* {!!files.find(
																						(f) => f.id === item._id
																					)?.name ? (
																						<Box>
																							{t('tasksForm.delete')}
																						</Box>
																					) : (
																						<Box
																							gap={'17px'}
																							display={'flex'}
																							alignItems={'center'}
																						>
																							<Text>
																								{t('tasksForm.addFile')}
																							</Text>
																							<CirclePlusIcon />
																						</Box>
																					)} */}

																			<Box
																				gap={'17px'}
																				display={'flex'}
																				alignItems={'center'}
																			>
																				<Text>{t('tasksForm.addFile')}</Text>
																				<CirclePlusIcon />
																			</Box>
																		</Button>
																		{/* {item.files && <span>{item.files.length}</span>} */}
																		{/* {item.notes && <span>{1}</span>} */}
																	</>
																)}

																<div className='flex items-center gap-4'>
																	{item.notes && <span>{1}</span>}
																	<Button
																		size='sm'
																		fontSize={21}
																		bg={style['primary-color']}
																		width='34px'
																		height='34px'
																		color={'white'}
																		onClick={() => {
																			setSelectedItem(item._id)
																			onOpen()
																		}}
																		disabled={isRiskLite}
																	>
																		<EditIcon scale={1.5} />
																	</Button>
																</div>
															</Box>

															<Box
																boxShadow='0px 0px 25px rgba(62, 62, 62, 0.08)'
																roundedBottom={'10px'}
															>
																<Accordion allowMultiple={true}>
																	<AccordionItem>
																		<AccordionButton
																			display={'flex'}
																			justifyContent={
																				isPc ? 'center' : 'space-between'
																			}
																			alignItems={'center'}
																			fontSize='16px'
																			fontWeight={400}
																			color='#3FB2D2'
																			gap={'9px'}
																			disabled={isRiskLite}
																		>
																			{!isPc && isOwner && (
																				<Box
																					display={'flex'}
																					gap={'9px'}
																					alignItems={'center'}
																				>
																					<Button
																						disabled={
																							// !!user ||
																							// !data?.date
																							!isOwner || isRiskLite
																						}
																						onClick={(ev) => {
																							ev.stopPropagation()
																							uploadFile(item._id)
																						}}
																						textAlign='center'
																						fontSize='18px'
																						fontWeight={700}
																						rounded={'100px'}
																						bg={'#fff'}
																						color={style['primary-color']}
																					>
																						<Box
																							gap={'17px'}
																							display={'flex'}
																							alignItems={'center'}
																						>
																							<Text>
																								{t('tasksForm.addFile')}
																							</Text>
																							<CirclePlusIcon />
																						</Box>
																					</Button>
																					{/* {item.files && (
																						<span>{item.files.length}</span>
																					)} */}
																					{/* {item.notes && <span>{1}</span>} */}
																				</Box>
																			)}
																			<Box
																				display={'flex'}
																				justifyContent='center'
																				alignItems={'center'}
																				fontSize='16px'
																				fontWeight={400}
																				// color={
																				// 	!!files.find(
																				// 		(f) => f.id === item._id
																				// 	)?.name || item.notes
																				// 		? 'red'
																				// 		: '#3FB2D2'
																				// }
																				gap={'9px'}
																			>
																				{t('tasksForm.additionalDetails')}
																				<AccordionIcon />{' '}
																				{item.files.length > 0
																					? `(${item.files.length} ${t(
																							'tasksForm.files'
																					  )})`
																					: ''}
																			</Box>
																		</AccordionButton>
																		<AccordionPanel>
																			{nextReset && (
																				<Box
																					display='flex'
																					// alignItems={'center'}
																					flexDirection='column'
																					// gap={'20px'}
																				>
																					<Text
																						fontSize={'18px'}
																						lineHeight='60px'
																						color={'#A9A9A9'}
																						fontWeight={400}
																					>
																						{`${t(
																							'tasksForm.nextReset'
																						)}: ${UtilSrvice.timestampToDDMMYYYY(
																							nextReset.getTime()
																						)}`}
																					</Text>
																					{/* <Text
																						fontSize={'18px'}
																						lineHeight='60px'
																						color={'#A9A9A9'}
																						fontWeight={400}
																					>
																						Last Reset:{' '}
																						{
																							new Date(
																								item.lastReset as Date
																							)
																								.toISOString()
																								.split('T')[0]
																						}
																					</Text>
																					({item.interval} *{' '}
																					{item.intervalAmount})
																					{item.dayOfMonth && (
																						<Text
																							fontSize={'18px'}
																							lineHeight='60px'
																							color={'#A9A9A9'}
																							fontWeight={400}
																						>
																							DAY OF MONTH:{' '}
																							{item.dayOfMonth}
																						</Text>
																					)} */}
																				</Box>
																			)}
																			{(item.files ?? []).map((file) => {
																				const { name, path } = file

																				return (
																					<Box
																						display={'flex'}
																						gap={'20px'}
																						alignItems={'center'}
																						className='lg:flex-row flex-col'
																						key={item._id}
																					>
																						<Text
																							fontSize={'18px'}
																							lineHeight='60px'
																							color={'#A9A9A9'}
																							fontWeight={400}
																							textAlign='center'
																						>
																							{/* {name ??
																										t(
																											'tasksForm.file'
																										) +
																											' ' +
																											id}
																									{file.date
																										? ` - ${UtilSrvice.timestampToDDMMYYYY(
																												file.date.getTime()
																										  )}`
																										: ''} */}
																							{name}
																						</Text>
																						<Button
																							display='flex'
																							padding={'15px'}
																							alignItems='center'
																							justifyContent='center'
																							gap={'20px'}
																							color={
																								style['primary-color']
																							}
																							width='max-content'
																							height='max-content'
																							bg={'#fff'}
																							isDisabled={isDownloading}
																							boxShadow='0px 0px 20px rgba(62, 62, 62, 0.11)'
																							onClick={() =>
																								downloadFile(
																									name,
																									`${
																										appConfig.apiUrl
																									}/file?path=${path}&token=${localStorage.getItem(
																										'token'
																									)}`
																								)
																							}
																						>
																							<DownloadIcon />
																							<Text color='#2D2F32'>
																								{t(
																									'tasksForm.download'
																								)}
																							</Text>
																						</Button>

																						<Button
																							display='flex'
																							padding={'15px'}
																							alignItems='center'
																							justifyContent='center'
																							gap={'20px'}
																							color={
																								style['primary-color']
																							}
																							width='max-content'
																							height='max-content'
																							bg={'#fff'}
																							boxShadow='0px 0px 20px rgba(62, 62, 62, 0.11)'
																							disabled={
																								isDownloading ||
																								!isOwner
																							}
																							onClick={() =>
																								deleteFile(
																									file.path,
																									item._id
																								)
																							}
																						>
																							<TrashIcon />
																							<Text color='#2D2F32'>
																								{t('tasksForm.delete')}
																							</Text>
																						</Button>
																					</Box>
																				)
																			})}

																			{item.notes && (
																				<Box>
																					<Text
																						fontSize={'18px'}
																						lineHeight='60px'
																						fontWeight={400}
																						color={'#A9A9A9'}
																					>
																						{t('tasksForm.comments')}
																					</Text>

																					<Text
																						fontSize={'16px'}
																						fontWeight={400}
																						bg={'#F8F9FA'}
																						padding='15px'
																						rounded={'3px'}
																					>
																						{item.notes}
																					</Text>
																				</Box>
																			)}
																		</AccordionPanel>
																	</AccordionItem>
																</Accordion>
															</Box>
														</Box>
													)
												})}
											</VStack>
										</VStack>
									</AccordionPanel>
								</AccordionItem>
							)
						})}
						{isOwner && (
							<Box
								display={'flex'}
								flexDirection='row-reverse'
							>
								<Button
									color={'white'}
									minW={isPc ? '200px' : 'full'}
									height='60px'
									textAlign='center'
									border='3px solid #FFFFFF'
									background={'#3FB2D2'}
									fontSize='18px'
									fontWeight={700}
									rounded={'100px'}
									filter='drop-shadow(0px 4px 30px rgba(63, 178, 210, 0.44))'
									disabled={isLoading || !isOwner}
									isLoading={isSubmitting}
									// isDisabled={data?.locked}
									marginTop='44px'
									onClick={handleSubmit}
								>
									{t('tasksForm.approve')}
								</Button>
							</Box>
						)}
					</Accordion>
				)}
			</Box>
		</Container>
	)
}

export default TasksForm
